export function isMobile(): boolean {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export function isStandalonePWA(): boolean {
  return window.matchMedia("(display-mode: standalone)").matches
    || (window.navigator as any).standalone === true; // iOS Safari
}